// extracted by mini-css-extract-plugin
export default {"loadingIcon":"Button_loadingIcon__aR-Vq","spin":"Button_spin__KS6s5","button":"Button_button__I9NM5"};